import {Component} from "../../../gvf/js/component";

export class TabsComponent extends Component{
    constructor(scope,$root){
        super(scope,$root);
    }

    ready(){
        super.ready();
        const isInModal = this.$root.closest(".modal").length>0;

        this.$root.find(".nav-link").on(
            "shown.bs.tab",
            (ev)=>{
                if(isInModal){
                    return;
                }
                const id = $(ev.currentTarget).attr("href").substr(1);
                window.location.hash = "#"+id+"tab";
            }
        ).click(
            (ev)=>{
                const $link = $(ev.currentTarget);
                if($link.attr("href").indexOf("#")==0){
                    ev.preventDefault();
                    $(ev.currentTarget).tab("show");
                }
            }
        );

        let hash = window.location.hash;
        if(!isInModal && hash && hash.endsWith("tab")){
            hash = hash.substring(0,hash.length-3);
            this.$root.find("a[href=\""+hash+"\"]").tab("show");
        }
    }
}

